<template>
    <div class="variable-selector">
        <!-- Değişken Ekleme Modal'ı -->
        <modal2 v-if="visible" title="Değişken Ekle" @cancel="closeModal" :showFooter="false" xlarge>
            <div class="variable-modal-content">
                <div class="variable-tabs">
                    <a-radio-group v-model="activeTab" button-style="solid">
                        <a-radio-button value="system">Sistem Değişkenleri</a-radio-button>
                        <a-radio-button value="custom">Özel Değişkenler</a-radio-button>
                    </a-radio-group>
                </div>

                <!-- Sistem Değişkenleri Tab'ı -->
                <div v-if="activeTab === 'system'" class="variable-list">
                    <a-table :dataSource="systemVariables" :pagination="false" rowKey="id">
                        <a-table-column title="Ad" dataIndex="name" key="name" width="250px" />
                        <a-table-column title="Açıklama" dataIndex="description" key="description" />
                        <a-table-column title="Örnek" dataIndex="example" key="example" width="200px" />
                        <a-table-column key="action" width="100px">
                            <template slot-scope="text, record">
                                <supsis-button primary small @click="insertVariable(record)">Ekle</supsis-button>
                            </template>
                        </a-table-column>
                    </a-table>
                </div>

                <!-- Özel Değişkenler Tab'ı -->
                <div v-if="activeTab === 'custom'" class="variable-list">
                    <div class="custom-variable-form">
                        <a-form-item :validateStatus="customVariableError ? 'error' : ''" :help="customVariableError">
                            <a-input
                                v-model="customVariableName"
                                placeholder="Yeni değişken adı (örn: musteri_adi)"
                                @keypress.enter="addCustomVariable"
                            />
                        </a-form-item>
                        <supsis-button primary @click="addCustomVariable">Ekle</supsis-button>
                    </div>

                    <div v-if="customVariables.length === 0" class="empty-variables">
                        <p>Henüz özel değişken eklenmemiş</p>
                    </div>

                    <a-table v-else :dataSource="customVariables" :pagination="false" rowKey="id">
                        <a-table-column title="Ad" dataIndex="name" key="name" width="250px" />
                        <a-table-column title="Açıklama" dataIndex="description" key="description" />
                        <a-table-column key="action" width="180px">
                            <template slot-scope="text, record, index">
                                <supsis-button primary small @click="insertVariable(record)" style="margin-right: 8px"
                                    >Ekle</supsis-button
                                >
                                <supsis-button danger small @click="removeCustomVariable(index)">Sil</supsis-button>
                            </template>
                        </a-table-column>
                    </a-table>
                </div>
            </div>
        </modal2>
    </div>
</template>

<script>
import Modal2 from "../../../../../components/common/Modal2.vue";
import SupsisButton from "@/views/Pages/Settings/components/SupsisButton.vue";

export default {
    name: "VariableSelector",
    components: {
        Modal2,
        SupsisButton,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        textareaRef: {
            type: Object,
            default: null,
        },
        currentText: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            activeTab: "system",
            customVariableName: "",
            customVariableError: "",
            customVariables: [],

            // Varsayılan sistem değişkenleri
            systemVariables: [
                {
                    id: "current_agent_state",
                    name: "{{current_agent_state}}",
                    description: "Current state name (for multi-state agents)",
                    example: '"greeting"',
                },
                {
                    id: "previous_agent_state",
                    name: "{{previous_agent_state}}",
                    description: "Previous state name",
                    example: '"qualification"',
                },
                {
                    id: "current_time",
                    name: "{{current_time}}",
                    description: "Current time in America/Los_Angeles",
                    example: '"Thursday, March 28, 2024 at 11:46:04 PM PST"',
                },
                {
                    id: "current_time_Europe/Istanbul",
                    name: "{{current_time_Europe/Istanbul}}",
                    description: "Current time in Europe/Istanbul",
                    example: '"Friday, March 29, 2024 at 09:46:04 AM TRT"',
                },
                {
                    id: "call_type",
                    name: "{{call_type}}",
                    description: 'Call type, "web_call" or "phone_call"',
                    example: '"phone_call"',
                },
                {
                    id: "direction",
                    name: "{{direction}}",
                    description: 'Call direction, "inbound" or "outbound"',
                    example: '"inbound"',
                },
                {
                    id: "user_number",
                    name: "{{user_number}}",
                    description: "User's phone number (from_number for inbound, to_number for outbound)",
                    example: '"+12137771234"',
                },
                {
                    id: "agent_number",
                    name: "{{agent_number}}",
                    description: "Agent's phone number (to_number for inbound, from_number for outbound)",
                    example: '"+12137771235"',
                },
            ],
        };
    },
    methods: {
        closeModal() {
            this.$emit("close");
        },

        validateCustomVariable() {
            const regex = /^[a-zA-Z0-9_]+$/;
            if (!this.customVariableName) {
                this.customVariableError = "Değişken adı boş olamaz";
                return false;
            }
            if (!regex.test(this.customVariableName)) {
                this.customVariableError = "Sadece harfler, rakamlar ve alt çizgi (_) kullanılabilir";
                return false;
            }
            this.customVariableError = "";
            return true;
        },

        addCustomVariable() {
            if (!this.validateCustomVariable()) return;

            const newVar = {
                id: this.customVariableName,
                name: `{{${this.customVariableName}}}`,
                description: "Özel değişken",
                example: "-",
                isCustom: true,
            };

            // Aynı isimde değişken var mı kontrol et
            const exists = this.customVariables.some((v) => v.id === newVar.id);
            if (!exists) {
                this.customVariables.push(newVar);
                this.customVariableName = "";
            } else {
                this.customVariableError = "Bu isimde bir değişken zaten var";
            }
        },

        insertVariable(variable) {
            this.$emit("insert-variable", variable);
        },

        removeCustomVariable(index) {
            this.customVariables.splice(index, 1);
        },
    },
};
</script>

<style scoped lang="scss">
.variable-selector {
    // Değişken Modal Stilleri
    .variable-modal-content {
        .variable-tabs {
            margin-bottom: 16px;
            display: flex;
            justify-content: center;
        }

        .variable-list {
            max-height: 400px;
            overflow-y: auto;

            .empty-variables {
                text-align: center;
                padding: 20px;
                color: #999;
                font-style: italic;
            }
        }

        .custom-variable-form {
            display: flex;
            margin-bottom: 16px;
            align-items: flex-start;

            .ant-form-item {
                flex: 1;
                margin-right: 10px;
                margin-bottom: 0;
            }
        }
    }
}
</style>
